import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-placement-builder',
  imports: [],
  templateUrl: './placement-builder.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './placement-builder.component.css'
})
export class PlacementBuilderComponent {

}
